<template>
  <v-container fluid>
    <material-card icon="mdi-clipboard-text" inline :title="franchiseeID ? companyName + ` ` + 'Kit Order' : 'Franchisee Kit Order'">
      <v-card-actions>
        <router-link :to="{ name: 'nodalView' }">
          <v-btn v-if="$vuetify.breakpoint.smAndUp" elevation="1" absolute right top> <v-icon left>mdi-arrow-left</v-icon>back</v-btn>
          <v-btn fixed v-else right fab small color="grey lighten-2" elevation="1" class="mr-n2 mt-10" style="opacity:.6;"> <v-icon>mdi-arrow-left</v-icon></v-btn>
        </router-link>
      </v-card-actions>
      <v-row>
        <v-col cols="12" sm="6" md="4">
          <v-dialog ref="dialog1" v-model="modal" :return-value.sync="fromDate" persistent width="290px">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field label="From Date" v-model="fromDate" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"></v-text-field>
            </template>
            <v-date-picker v-model="fromDate" scrollable>
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="modal = false">
                Cancel
              </v-btn>
              <v-btn text color="primary" @click="$refs.dialog1.save(fromDate)">
                OK
              </v-btn>
            </v-date-picker>
          </v-dialog>
        </v-col>
        <v-col cols="12" sm="6" md="4">
          <v-dialog ref="dialog" v-model="modal1" :return-value.sync="toDate" persistent width="290px">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field label="To Date" v-model="toDate" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"></v-text-field>
            </template>
            <v-date-picker v-model="toDate" scrollable>
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="modal1 = false">
                Cancel
              </v-btn>
              <v-btn text color="primary" @click="$refs.dialog.save(toDate)">
                OK
              </v-btn>
            </v-date-picker>
          </v-dialog>
        </v-col>
      </v-row>

      <v-card-text class="pt-0 pr-1" :class="{ 'd-block py-3': $vuetify.breakpoint.xs, 'd-flex align-center': $vuetify.breakpoint.smAndUp }">
        <v-text-field
          :class="{ 'mr-0': $vuetify.breakpoint.xs, 'mr-5': $vuetify.breakpoint.smAndUp }"
          v-model="search"
          append-icon="mdi-magnify"
          class="ml-auto mb-2"
          label="Search"
          hide-details
          single-line
          style="max-width:350px;"
        />
      </v-card-text>
      <v-divider class=" my-0 " />
      <v-data-table sort-by hide-default-footer :items-per-page="-1" :headers="headers" :items="tableData" :search="search" item-key="index">
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-toolbar-title>{{ franchiseeID ? companyName + ` ` + 'Kit Order' : 'Franchisee Kit Order' }}</v-toolbar-title>
          </v-toolbar>
        </template>
        <template v-slot:item.action="{ item }">
          <v-btn :disabled="!cancelorderbutton || item.status !== 'PENDING' || item.kitType == 'CURRICULUM_KIT_1'" @click="cancelOrder(item.orderID,item.status)" class="px-2 ml-1 ma-1" color="error" min-width="0" small
            >Cancel Order
          </v-btn>
        </template>
      </v-data-table>
    </material-card>
  </v-container>
</template>
<script>
// import CONSTANTS from '@/utils/constants'
import MaterialCard from '@/components/template/MaterialCard'
import Utils from '@/utils'
import constants from '@/utils/constants'
import { mapGetters } from 'vuex'
import moment from 'moment'
import _ from 'lodash'
import stores from '@/stores'

export default {
  components: { MaterialCard },
  name: 'franchiseeOrderNodal',
  data () {
    return {
      isLoading: false,
      companyName: '',
      modal: false,
      academicYearID: '',
      modal1: false,
      fromDate: moment(new Date())
        .subtract(1, 'month')
        .format('YYYY-MM-DD'),
      toDate: new Date().toISOString().substr(0, 10),
      expanded: [],
      singleExpand: true,
      inProgress: false,
      search: '',
      franchiseeID: '',
      headers: [
        { text: 'Sr.No', sortable: true, value: 'index' },
        { text: 'Student Name ', value: 'enquiry.studentFirstName', sortable: true },
        { text: 'Class', value: 'studentClass.name', sortable: true },
        { text: 'Enquiry Code', value: 'enquiry.enquiryCode', sortable: true },
        { text: 'Kit Type', sortable: true, value: 'kitType' },
        { text: 'BOM name', sortable: true, value: 'kitSetMap.name' },
        // { text: 'Subscription Month', value: 'subscriptionMonth', sortable: true },
        { text: 'Amount ', value: 'amount', sortable: true },
        { text: 'Amount Due', value: 'amountDue', sortable: true },
        { text: 'Amount Paid', value: 'amountPaid', sortable: true },
        { text: 'Status ', value: 'status', sortable: true },
        // { text: 'Description ', value: 'description', sortable: true },
        { text: 'Order Id ', value: 'orderID', sortable: true },
        { text: 'Order Time ', value: 'orderTime', sortable: true },
        { text: 'Action', value: 'action', sortable: true }
      ],
      tableData: [],
      cancelorderbutton: false
    }
  },
  async created () {
    await this.onFranchiseeChange()

    this.cancelorderbutton = stores.user.ACL.superAdmin ||
                         stores.user.roles.some(item => item.role === 'CANCEL_ORDER_BUTTON')
  },
  watch: {
    franchisee: async function (val) {
      this.companyName = val.companyName
      await this.onFranchiseeChange()
    },
    toDate: async function (val) {
      await this.onFranchiseeChange()
    },
    fromDate: async function (val) {
      await this.onFranchiseeChange()
    },
    academicYear: async function (val) {
      await this.onFranchiseeChange()
    }
  },
  computed: {
    ...mapGetters({
      franchisee: 'getFranchisee',
      academicYear: 'getAcademicYear'
    })
  },
  methods: {
    onFranchiseeChange: async function () {
      if (!this.inProgress) {
        this.inProgress = true
        if (this.franchisee) {
          this.franchiseeID = this.franchisee.id
        } else {
          this.franchiseeID = ''
        }
        if (this.academicYear) {
          this.academicYearID = this.academicYear.id
        } else {
          this.academicYearID = ''
        }
        Utils.helper.openDrawer(this, !this.franchiseeID)
        if (this.franchiseeID) {
          await this.onStart()
        }
        this.inProgress = false
      }
    },
    onStart: async function () {
      if (!this.franchiseeID) {
        return this.$dialog.error({
          text: 'Please select Franchisee',
          title: 'Error'
        })
      }
      try {
        this.isLoading = true
        const { data } = await http.get(
          `${constants.API_URL}/api/franchisee-assigned-orders?franchiseeID=${this.franchiseeID}&fromDate=${this.fromDate}&toDate=${this.toDate}&academicYearID=${this.academicYearID}`
        )
        this.tableData = data

        _.map(this.tableData, (obj, key) => {
          obj.index = key + 1
          obj.enquiry.studentFirstName = obj.enquiry.studentFirstName + ` ` + obj.enquiry.studentLastName
          obj.orderTime = new Date(obj.orderTime).toLocaleString()
        })

        console.log('data--', data)
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        return this.$dialog.error({
          text: errorMessage,
          title: 'Error'
        })
      } finally {
        this.isLoading = false
      }
    },
    cancelOrder: async function (orderID, status) {
      console.log('order is cancelled')

      this.$buefy.dialog.confirm({
        title: 'Confirm Order',
        message: 'Are you sure you want to cancel this order?',
        confirmText: 'Yes',
        cancelText: 'No',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: async () => {
          try {
            this.isLoading = true
            let payLoad = {
              orderID: orderID,
              status: status
            }

            let res = await http.patch(`${constants.API_URL}/api/order/cancel-assign-order`, payLoad)
            console.log(res, 'res')
            this.okMsg('Order Cancelled successfully!')
            await this.onStart()
          } catch (e) {
            const errorMessage = (e && e.response && e.response.data.message) || e.message

            this.errMsg(errorMessage)
          } finally {
            this.isLoading = false
          }
        }
      })
    },
    okMsg (msg) {
      return this.$dialog.info({
        title: 'Success',
        text: msg
      })
    },
    errMsg (msg) {
      return this.$buefy.dialog.alert({
        message: msg,
        type: 'is-danger',
        hasIcon: true,
        animation: 'zoom-out',
        size: 'is-medium',
        icon: ' mdi-exclamation',
        iconPack: 'mdi',
        ariaRole: 'alertdialog',
        ariaModal: true
      })
    }
  }
}
</script>
